// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CrLXPcsrVQUlo1usomSi{background:var(--black-10);border-radius:6px;flex:none;justify-content:center;align-items:center;min-width:20px;height:20px;display:inline-flex}.dnP4oHekl0ZLdf6qKosI{border:1px solid var(--border-neutral-default);border-radius:6px}.VNRVocAVZxwJFBCD5oCk{padding:7px 7px 7px 11px}.l4Ib1EsEW3QAPPbEtZL9{margin-left:auto}.BqxVvBt9IwxDSRYOaOQE{padding-left:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepBox": `CrLXPcsrVQUlo1usomSi`,
	"recordsWrap": `dnP4oHekl0ZLdf6qKosI`,
	"record": `VNRVocAVZxwJFBCD5oCk`,
	"copyButton": `l4Ib1EsEW3QAPPbEtZL9`,
	"recordLabel": `BqxVvBt9IwxDSRYOaOQE`
};
export default ___CSS_LOADER_EXPORT___;
